import { Component, input } from '@angular/core';
import { RaSquareIconComponent } from 'src/app/shared/components/ra-square-icon/ra-square-icon.component';
import { RaIconComponent } from 'src/app/shared/components/ra-icon/ra-icon.component';
import { RaTooltipDirective } from 'src/app/shared/directives';

@Component({
    selector: 'section-item',
    templateUrl: 'section-item.component.html',
    styleUrl: 'section-item.component.scss',
    imports: [RaSquareIconComponent, RaTooltipDirective, RaIconComponent],
})
export class SectionItemComponent {
    public icon = input<string>('');
    public text = input<string>('');
    public type = input<'success' | 'danger'>();
    public tooltipPosition = input<'top' | 'bottom' | 'left' | 'right'>('left');
}
